import { FilterState } from '../Schema/FilterState';
import { createStore } from 'satcheljs';
import { FileExtensionType } from 'owa-files-filter-file-extensions-filter';

const initialStore: FilterState = {
    extensionGroupFilter: {
        selectedValue: new Map<string, string>(),
    },
    broadExtensionGroupFilter: {
        selectedValue: null,
        options: [FileExtensionType.Files, FileExtensionType.Images], // order matters
    },
    dateRangeFilter: {
        selectedValue: { option: null, dateRange: null },
    },
    folderFilter: { selectedValue: null },
    photosOnlyFilter: { selectedValue: false },
    sizeFilter: {
        selectedValue: null,
        options: [512000, 1048576, 3072000, 5242880, 10485760], // sizes in bytes - order matters
    },
    searchFilter: { selectedValue: null }, // Will be a querystring that combines text/persona data for the SearchAPI
    columnSort: { selectedValue: [0] }, // 0 is default column sort, sorted by descending AttachmentReceivedTime
};

export const getFilterStore = createStore<FilterState>('FilesViewFilterStore', initialStore);
